import { render, staticRenderFns } from "./masterNotification.vue?vue&type=template&id=45ad5346&"
import script from "./masterNotification.vue?vue&type=script&lang=js&"
export * from "./masterNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports